import Joi from '@hapi/joi';

export const zxyRegisterSchema = Joi.object().keys({
    name: Joi.string().required(),
    apiPath: Joi.string().allow(null),
    isZxyCloudClient: Joi.boolean().allow(null),
    isAllowedReadObjectList: Joi.boolean().allow(null),
    isAllowedReadSurveyList: Joi.boolean().allow(null),
    isAllowedReadObjectData: Joi.boolean().allow(null),
    isAllowedReadSurveyData: Joi.boolean().allow(null),
    isAllowedUpdateObject: Joi.boolean().allow(null),
    isAllowedAddObject: Joi.boolean().allow(null),
    isAllowedAddSurvey: Joi.boolean().allow(null),
    isProduction: Joi.boolean().allow(null),
});
